module.exports = __webpack_public_path__ + "img/salong_code.ca610349.png";